import { useTranslation } from 'react-i18next';
import NewCheckbox from '../NewCheckbox/NewCheckbox';
import './NewSectionHeader.css';

export interface NewSectionHeaderProps {
  label: string;
  checked?: boolean;
  indeterminate?: boolean;
  onCheckboxChange?: (_checked: boolean) => void;
  showCheckbox?: boolean;
  leftContent?: React.ReactNode;
  /** Content right after the label, e.g. icon actions that belong to the title. */
  afterLabel?: React.ReactNode;
  rightContent?: React.ReactNode;
  className?: string;
}

/**
 * NewSectionHeader — collapsible / selectable section bar for PIM panels.
 * Optional leading checkbox for bulk-select. Left, after-label and right slots for action buttons.
 */
function NewSectionHeader({
  label,
  checked = false,
  indeterminate = false,
  onCheckboxChange,
  showCheckbox = false,
  leftContent,
  afterLabel,
  rightContent,
  className,
}: NewSectionHeaderProps) {
  const { t: tRaw } = useTranslation('pim');
  const rootClass = ['new-section-header', className].filter(Boolean).join(' ');
  return (
    <div className={rootClass}>
      <div className="new-section-header__left">
        {leftContent}
        {showCheckbox ? (
          <NewCheckbox
            checked={checked}
            indeterminate={indeterminate}
            onChange={(e) => onCheckboxChange?.((e.target as HTMLInputElement).checked)}
            aria-label={String(tRaw('PIM.COMMON.SELECT_ALL_IN', { label }))}
          />
        ) : null}
        <span className="new-section-header__label">{label}</span>
        {afterLabel}
      </div>
      {rightContent ? <div className="new-section-header__right">{rightContent}</div> : null}
    </div>
  );
}

export default NewSectionHeader;
